<template>
  <ModalFormWrapper title="Pridanie vozidla" swipe-to-close @popup-closed="resetData">
    <FirstStep @submit="Vehicles.addVehicle({ ecv, brand, model, color })" />
  </ModalFormWrapper>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import Vehicles from '@/assets/classes/parking/Vehicles'
import { useVehicleData } from '@/assets/composables/parking/useVehicleData'
import FirstStep from '@/components/parking/vehicleForm/firstStep.vue'
import ModalFormWrapper from '@/components/wrappers/ModalFormWrapper.vue'

const { ecv, brand, model, color, validation, validateForm, resetData } = useVehicleData()

provide('formData', {
  ecv,
  brand,
  model,
  color,
  validation,
  validateForm,
})
</script>
